import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

// Components
import Header from "./components/Header";
import RoleChooser from "./components/RoleChooser";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import FAQSection from "./components/FAQ";
import TestimonialsSection from "./components/Testimonials";
import Footer from "./components/Footer";
import Portfolio from "./pages/Portfolio";
import WebDev from "./pages/WebDev";
import WebPortfolio from "./pages/WebPortfolio";
import Realisations from "./pages/Realisations";
import { Toaster } from "./components/ui/toaster";

// Admin Components
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import Login from "./pages/admin/Login";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import Dashboard from "./pages/admin/Dashboard";
import VideoManagement from "./pages/admin/VideoManagement";
import WebProjects from "./pages/admin/WebProjects";
import Messages from "./pages/admin/Messages";
import Categories from "./pages/admin/Categories";
import WebCategories from "./pages/admin/WebCategories";
import FAQ from "./pages/admin/FAQ";  
import Testimonials from "./pages/admin/Testimonials";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <RoleChooser />
        <About />
        <Services />
        <TestimonialsSection />
        <FAQSection />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/realisations/video" element={<Portfolio />} />
            <Route path="/realisations/web" element={<WebPortfolio />} />
            <Route path="/web-dev" element={<WebDev />} />
            
            {/* Admin Auth Routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            
            {/* Protected Admin Routes */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/videos" 
              element={
                <ProtectedRoute>
                  <VideoManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/web-projects" 
              element={
                <ProtectedRoute>
                  <WebProjects />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/videos/new" 
              element={
                <ProtectedRoute>
                  <VideoManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/messages" 
              element={
                <ProtectedRoute>
                  <Messages />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/categories" 
              element={
                <ProtectedRoute>
                  <Categories />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/web-categories" 
              element={
                <ProtectedRoute>
                  <WebCategories />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/faq" 
              element={
                <ProtectedRoute>
                  <FAQ />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/testimonials" 
              element={
                <ProtectedRoute>
                  <Testimonials />
                </ProtectedRoute>
              } 
            />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
